import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { useFragment } from "react-relay";
import { PaediaContentElement_ContentSubmissionFragment$key } from "@generated/PaediaContentElement_ContentSubmissionFragment.graphql";
import { PaediaMultipleChoiceElementPart } from "./PaediaMultipleChoiceElementPart.component";
import { FileElementPart } from "../../../infecto-lms-webapp/components/content-element/file/FileElementPart.component";
import { PodcastElementPart } from "../../../infecto-lms-webapp/components/content-element/podcast/PodcastElementPart.component";
import { TextElementPart } from "../../../infecto-lms-webapp/components/content-element/text/TextElementPart.component";
import { VideoElementPart } from "../../../infecto-lms-webapp/components/content-element/video/VideoElementPart.component";

const CONTENT_SUBMISSION_FRAGMENT = graphql`
	fragment PaediaContentElement_ContentSubmissionFragment on ContentSubmission {
		definition {
			... on ActiveELearningContentSubmissionDefinition {
				currentElementState {
					element {
						elementType
					}
				}
			}
		}
		...FileElementPart_ContentSubmissionFragment
		...PaediaMultipleChoiceElementPart_ContentSubmissionFragment
		...PodcastElementPart_ContentSubmissionFragment
		...TextElementPart_ContentSubmissionFragment
		...VideoElementPart_ContentSubmissionFragment
	}
`;

interface OwnProps {
	contentSubmissionFragmentRef: PaediaContentElement_ContentSubmissionFragment$key;
}

export function PaediaContentElement({ contentSubmissionFragmentRef }: OwnProps) {
	const contentSubmission = useFragment<PaediaContentElement_ContentSubmissionFragment$key>(
		CONTENT_SUBMISSION_FRAGMENT,
		contentSubmissionFragmentRef,
	);

	switch (contentSubmission.definition.currentElementState?.element.elementType) {
		case "file":
			return <FileElementPart contentSubmissionFragmentRef={contentSubmission} />;
		case "multipleChoice":
			return <PaediaMultipleChoiceElementPart contentSubmissionFragmentRef={contentSubmission} />;
		case "podcast":
			return <PodcastElementPart contentSubmissionFragmentRef={contentSubmission} />;
		case "text":
			return <TextElementPart contentSubmissionFragmentRef={contentSubmission} />;
		case "video":
			return <VideoElementPart contentSubmissionFragmentRef={contentSubmission} />;
		default:
			return (
				<div>
					Unbekannter Elementtyp:{" "}
					{contentSubmission.definition.currentElementState?.element.elementType}
				</div>
			);
	}
}
